import axios from 'axios'
import qs from 'qs'

// axios.defaults.timeout = 5000;                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json'; //配置请求头
axios.defaults.headers.common['Authorization'] = localStorage.getItem('_adtoken'); //配置请求头
// axios.defaults.baseURL = 'http://192.168.40.191:8000'; //配置接口地址
axios.defaults.baseURL = process.env.API_ROOT;

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    //在发送请求之前做某件事
    if (config.method === 'post') {
        // config.data = qs.stringify(config.data);
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
    //对响应数据做些事
    if (!res.data.success) {
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
        // this.$message.warning("网络异常");
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: param })
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
////返回一个Promise(发送get请求)
export function fetchDownload(url, param) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url,
            params: param,
            responseType: 'blob'
        }).then(response => {
            resolve(response)
        })
    })
}
////返回一个Promise(发送get请求)
export function fetchPut(url, param) {
    return new Promise((resolve, reject) => {
        axios.put(url, param)
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function config(token) {
    axios.defaults.headers.common['Authorization'] = token;
}
export default {
    fetchDownload,
    fetchPost,
    fetchGet,
    config,
    fetchPut
}


// WEBPACK FOOTER //
// ./src/http/httprequest.js